import { HttpClient } from '@wix/http-client';

export const httpClient = new HttpClient();
